import React from "react";

import { useGetFieldShape } from "utils";

import { FieldListField } from "models";

import { MapStatic, Skeleton } from "components";

// shared by historical-practice-data-table-view/MissingDataTable.tsx and all-fields-data-table-view/AllFieldsDataTable.tsx
export const FieldMap = ({ field }: { field: FieldListField }) => {
  const { fieldShape, fieldShapeLoading } = useGetFieldShape({ fieldId: field.id });

  return (
    <div className="historical-practice-data-table-view-field-map-container">
      {fieldShapeLoading ? (
        <div className="historical-practice-data-table-view-field-map-skeleton-container">
          <Skeleton type="block" width="100%" height="100%" />
        </div>
      ) : (
        // @ts-expect-error need to convert this to TS
        <MapStatic field={field} geometry={fieldShape} location={field.location} />
      )}
    </div>
  );
};
